import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { AppFunctionComponent } from "../../../../../types"
import FeaturedStoriesSlider from "../../../../community/blog/featured-stories-slider"
import Section from "../../../../common/sections/section.component"

const BlogFeaturedStories: AppFunctionComponent = () => {
  const { featuredPosts } = useStaticQuery(query)

  return (
    <Section>
      <FeaturedStoriesSlider posts={featuredPosts.nodes} />
    </Section>
  )
}

export default BlogFeaturedStories

export const query = graphql`
  query BlogFeaturedStoriesQuery {
    featuredPosts: allContentfulBlogPost(
      filter: { postFeatured: { eq: true } }
      sort: { fields: postOriginalPublishDate, order: DESC }
    ) {
      nodes {
        postSlug
        postTitle
        postOriginalPublishDate
        postOriginalPublishDateFormatted: postOriginalPublishDate(
          formatString: "MMM D, YYYY"
        )
        postTags {
          text
        }
        postExcerpt {
          postExcerpt
        }
        postFeaturedImage {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: BLURRED
            quality: 100
            width: 600
          )
          title
          description
        }
      }
    }
  }
`
